import { ApplicationHttpClient } from '@base/http-client';
import { IDialogSearchParams } from '@interfaces';
import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { ROLES, COMPANY, MODULE } from '@utils';
import { moduleRoutes as userRoutes } from '@user/urlmap';
import { moduleRoutes as companyRoutes } from '@company/urlmap';
import { moduleRoutes as moduleRoutes } from './../../module/urlmap';

@Injectable()
export class SearchService {
  // baseUrl = 'https://api.cdnjs.com/libraries';
  // queryUrl = '?search=';
  private _queryParams: IDialogSearchParams;
  private _mapRoutes;
  private _endPoint: string;
  private _isUser: boolean;

  constructor(
    // private http: Http,
    private httpClient: ApplicationHttpClient,
  ) { }

  search(terms: Observable<string>, params: IDialogSearchParams) {
    this._queryParams = params;
    this._isUser = (this._queryParams.filter === ROLES.CUSTOMER || this._queryParams.filter === ROLES.ANALYST
      || this._queryParams.filter === ROLES.LEADER || this._queryParams.filter === ROLES.ADMIN);
    const isCompany = (this._queryParams.filter === COMPANY);
    const isModule = (this._queryParams.filter === MODULE);

    if (this._isUser) {
      this._mapRoutes = userRoutes;
      this._endPoint = this._mapRoutes['getUser'];
    } else if (isCompany) {
      this._mapRoutes = companyRoutes;
      this._endPoint = this._mapRoutes['list'];
    } else if (isModule) {
      this._mapRoutes = moduleRoutes;
      this._endPoint = this._mapRoutes['list'];
    }

    return terms.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(term => {
          // return this.searchEntries(term);
          return this.searchTerms(term);
        })
    );
  }

  searchTerms(term) {
    const queryParams: object = {
      search: term,
    };

    if (this._isUser) {
      queryParams[this._queryParams.searchKey] = this._queryParams.filter;
    }

    return this.httpClient
        .Get(this._endPoint, queryParams).pipe(
            map(res => res['results'])
        );
  }

  // searchEntries(term) {
  //   return this.http
  //       .get(this.baseUrl + this.queryUrl + term).pipe(
  //           map(res => res.json())
  //       );
  // }
}
